import React from 'react';

import { Wrapper, Container, StyledRingC, StyledRingD } from './WeekCalendar.styled';

import RingD from 'Public/graphics/fiftyTwoThings/ring-id-d.png';

export interface Props {
    week: number;
    color?: string;
    className?: string;
}

const WeekCalendar: React.FC<Props> = ({ className, week, color }) => {
    return (
        <Wrapper
            className={className}
            title={`Week ${week} of 52`}
            style={
                {
                    '--week-color': color
                } as React.CSSProperties
            }
        >
            <Container>
                <svg
                    width="350"
                    height="350"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 360 360"
                >
                    <path
                        d="M325 28.9H35c-11 0-20 9-20 20v290c0 11 9 20 20 20h290c11 0 20-9 20-20v-290c0-11.1-9-20-20-20Zm-46.2 20.8c12.1 0 21.9 9.8 21.9 21.9 0 12.1-9.8 21.9-21.9 21.9-12.1 0-21.9-9.8-21.9-21.9 0-12.1 9.8-21.9 21.9-21.9Zm-198 0c12.1 0 21.9 9.8 21.9 21.9 0 12.1-9.8 21.9-21.9 21.9-12.1 0-21.9-9.8-21.9-21.9 0-12.1 9.8-21.9 21.9-21.9Z"
                        fill="#D7D7D7"
                    />
                    <text
                        x="50%"
                        y="67%"
                        dominantBaseline="middle"
                        textAnchor="middle"
                        fontSize="220"
                        fill="currentColor"
                        fontWeight={800}
                    >
                        {week}
                    </text>
                    <path
                        d="M325 28.9H35c-11 0-20 9-20 20v52h330v-52c0-11.1-9-20-20-20ZM80.8 93.5c-12.1 0-21.9-9.8-21.9-21.9 0-12.1 9.8-21.9 21.9-21.9 12.1 0 21.9 9.8 21.9 21.9 0 12.1-9.8 21.9-21.9 21.9Zm198 0c-12.1 0-21.9-9.8-21.9-21.9 0-12.1 9.8-21.9 21.9-21.9 12.1 0 21.9 9.8 21.9 21.9 0 12.1-9.8 21.9-21.9 21.9Z"
                        fill="currentColor"
                    />
                    <path fill="url(#a)" d="M262.55 0h33v89.43h-33z" />
                    <path fill="url(#b)" d="M64.27 0h32.67v89.43H64.27z" />
                    <defs>
                        <pattern
                            id="a"
                            patternContentUnits="objectBoundingBox"
                            width="1"
                            height="1"
                        >
                            <use xlinkHref="#c" transform="scale(.01 .00369)" />
                        </pattern>
                        <pattern
                            id="b"
                            patternContentUnits="objectBoundingBox"
                            width="1"
                            height="1"
                        >
                            <use xlinkHref="#d" transform="scale(.0101 .00369)" />
                        </pattern>
                    </defs>
                </svg>
                <StyledRingD src={RingD} alt="" />
                <StyledRingC src={RingD} alt="" />
            </Container>
        </Wrapper>
    );
};

export default WeekCalendar;
